// Core Angular
import angular from 'angular';
import angularPl from './angular-pl';
import ngSanitizeModuleName from 'angular-sanitize';
import * as moment from 'moment';

// Libs
import angularUiTree from 'angular-ui-tree';
import angularTooltips from 'angular-tooltips';
import angularClickOutside from '@iamadamjowett/angular-click-outside';
import uiRouter from '@uirouter/angularjs';
import angularModalService from 'angular-modal-service';
import angularAnimate from 'angular-animate';
import angularMaterial from 'angular-material';
import angularMessages from 'angular-messages';
import textAngular from 'textangular';
import angularUtilsDirectivesDirPagination from 'angular-utils-pagination/dirPagination';

// FE
import configuratorSelectComponent from './configurator/select.component';
import configuratorActionComponent from './configurator/action.component';
import configuratorComponent from './configurator/configurator.component';
import previewComponent from './preview/preview.component';
import configuratorPrintsComponent from './configuratorPrints/configuratorPrints.component';
import configuratorService from './configurator/configurator.service';
import FocusedDirective from './configurator/focused.directive';
import CustomQueryPreviewComponent from './preview/customQueryPreview.component';
import cartService from './cart/cart.service';
import cartItemComponent from './cart/cartItem.component';
import cartItemService from './cart/cartItem.service';
import cartCountComponent from './cart/cartcount.component';
import cartDropdownContentComponent from './cart/cartdropdowncontent.component';
import cartDropdownComponent from './cart/cartdropdown.component';
import ElementWidthDirective from './elementWidth.directive';
import ScrollToPageTopDirective from './scrollToPageTop.directive';
import DisplayWhenBelowDirective from './displayWhenBelow.directive';
import FitContentDirective from './checkout/fitContent.directive';
import configuratorManualFeComponent from './configuratorManual/configuratorManualFe.component';
import complaintFeComponent from './complaint/complaintFe.component';
import SelectNgFilesDirective from './selectNgFiles.directive';
import ClickOutsideDirective from './clickoutside.directive';
import productFileComponent from './order/productFile.component';
import PostfixDirective from './configurator/postfix.directive';
import UserRenamingConfiguratorManualDirective from './userRenamingConfiguratorManual.directive';
import ToastController from './toast/toast.controller';
import priceTypeService from './price/priceType.service';
import priceTypeComponent from './price/priceType.component';
import orderDetailsComponent from './order/orderDetails.component.js';
import myProductsComponent from './myProducts/myProducts.component.js';
import materialStiffnessCalculatorComponent from './materialStiffnessCalculator/materialStiffnessCalculator.component';
import discountClubHistoriesComponent from './discountClubHistories/discountClubHistories.component';

// Checkout
import CheckoutService from './checkout/checkout.service';
import checkoutItemsComponent from './checkout/checkoutitems.component';
import checkoutShipmentComponent from './checkout/checkoutshipment.component';
import checkoutSummaryComponent from './checkout/checkoutsummary.component';
import checkoutControlsComponent from './checkout/checkoutcontrols.component';
import checkoutDataLoggedComponent from './checkout/checkoutdatalogged.component';
import checkoutDataNotLoggedComponent from './checkout/checkoutdatanotlogged.component';
import checkoutAddNewAddressComponent from './checkout/checkoutaddnewaddress.component';
import checkoutPaymentComponent from './checkout/checkoutpayment.component';
import checkoutConfirmationComponent from './checkout/checkoutconfirmation.component';
import uploadPrintFileOrderPlacedComponent from './uploadPrintFileOrderPlaced/uploadPrintFileOrderPlaced.component';
import snackbarService from './checkout/snackbar.service';
import snackbarComponent from './checkout/snackbar.component';
import cookieWallComponent from './cookieWall/cookieWall.component';
import registerComponent from './register/register.component';
import userAddressComponent from './userAddress/userAddress.component';

// ADM
import dashboardComponent from './dashboard/dashboard.component';
import materialsComponent from './materials/materials.component';
import treeComponent from './materials/tree.component';
import materialsService from './materials/materials.service';
import orderComponent from './order/order.component';
import orderService from './order/order.service';
import configuratorManualAdmComponent from './configuratorManual/configuratorManualAdm.component';
import configuratorManualNewAdmComponent from './configuratorManual/configuratorManualNewAdm.component';
import configuratorValuationAdmComponent from './configuratorValuations/configuratorValuationAdm.component';
import complaintAdmComponent from './complaint/complaintAdm.component';
import userCategoriesPromoThresholdsComponent from './userCategoriesPromoThresholds/userCategoriesPromoThresholds.component';
import adminReplacingComarchInvoiceComponent from './adminReplacingComarchInvoice/adminReplacingComarchInvoice.component';
import adminAddComarchInvoiceComponent from './adminAddComarchInvoice/adminAddComarchInvoice.component';
import configuratorPrintsAdmComponent from './configuratorPrints/configuratorPrintsAdm.component';
import printsService from './configuratorPrints/prints.service';
import paczkomatyTargetPointInpostGeowidgetComponent from './paczkomatyTargetPointInpostGeowidget/paczkomatyTargetPointInpostGeowidget.component';

// Universal
import translateService from './translate/translate.service';
import translateFilter from './translate/translate.filter';
import priceComponent from './price/price.component';
import MaxCharsDirective from './configurator/maxChars.directive';
import OnlyNumbersDirective from "./configurator/onlyNumbers.directive";
import MaxMainShapeTextHeightDirective from "./configurator/maxMainShapeTextHeight.directive";
import uploaderComponent from './uploader/uploader.component';
import CollapseDirective from './collapse.directive';
import ConfirmationDirective from './confirmation.directive';
import AutogrowDirective from "./autogrow.directive";

const dependencies = [
    ngSanitizeModuleName,
    uiRouter,
    angularUiTree,
    angularTooltips,
    'angularModalService',
    'angular-click-outside',
    angularAnimate,
    angularMaterial,
    angularMessages,
    textAngular,
    'angularUtils.directives.dirPagination'
];

let configuratorApp = angular.module('contra', dependencies)
    // FE
    .component('configuratorSelect', configuratorSelectComponent)
    .component('configuratorAction', configuratorActionComponent)
    .component('configurator', configuratorComponent)
    .component('preview', previewComponent)
    .component('configuratorPrints', configuratorPrintsComponent)
    .service('configuratorService', configuratorService)
    .service('cartService', cartService)
    .component('cartCount', cartCountComponent)
    .component('cartDropdownContent', cartDropdownContentComponent)
    .component('cartDropdown', cartDropdownComponent)
    .component('cartItem', cartItemComponent)
    .service('cartItemService', cartItemService)
    .directive('elementWidth', ElementWidthDirective.directiveFactory)
    .directive('focused', FocusedDirective.directiveFactory)
    .directive('maxChars', MaxCharsDirective.directiveFactory)
    .directive('maxMainShapeTextHeight', MaxMainShapeTextHeightDirective.directiveFactory)
    .directive('onlyNumbers', OnlyNumbersDirective.directiveFactory)
    .component('customQueryPreview', CustomQueryPreviewComponent)
    .directive('scrollToPageTop', ScrollToPageTopDirective.directiveFactory)
    .component('configuratorManualFe', configuratorManualFeComponent)
    .component('complaintFe', complaintFeComponent)
    .directive('selectNgFiles', SelectNgFilesDirective.directiveFactory)
    .directive('clickOutside', ClickOutsideDirective.directiveFactory)
    .directive('userRenamingConfiguratorManual', UserRenamingConfiguratorManualDirective.directiveFactory)
    .directive('collapse', CollapseDirective.directiveFactory)
    .directive('onEnter', function() {
        return function(scope, elm, attr) {
            elm.bind('keydown keypress', function(e) {
                if (e.key === 'Enter') {
                    scope.$apply(function() {
                        scope.$eval(attr.onEnter);
                    });

                    e.preventDefault();
                }
            });
            scope.$on('$destroy', function() {
                elm.unbind('keydown keypress')
            });
        };
    })
    .directive('onEscape', function() {
        return function(scope, elm, attr) {
            elm.bind('keydown keypress', function(e) {
                if (e.key === 'Escape') {
                    scope.$apply(function() {
                        scope.$eval(attr.onEscape);
                    });

                    e.preventDefault();
                }
            });
            scope.$on('$destroy', function() {
                elm.unbind('keydown keypress')
            });
        };
    })
    // ADM
    .component('materials', materialsComponent)
    .component('materialsTree', treeComponent)
    .component('configuratorPrintsAdm', configuratorPrintsAdmComponent)
    .service('materialsService', materialsService)
    .service('printsService', printsService)
    .component('order', orderComponent)
    .service('orderService', orderService)
    .component('dashboard', dashboardComponent)
    .component('configuratorManualAdm', configuratorManualAdmComponent)
    .component('configuratorManualNewAdm', configuratorManualNewAdmComponent)
    .component('configuratorValuationAdm', configuratorValuationAdmComponent)
    .component('complaintAdm', complaintAdmComponent)
    .service('translateService', translateService)
    .filter('t', translateFilter)
    .filter('nl2br', function($sce){
        return function(msg,is_xhtml) {
            var is_xhtml = is_xhtml || true;
            var breakTag = (is_xhtml) ? '<br />' : '<br>';
            var msg = (msg + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
            return $sce.trustAsHtml(msg);
        }
    })
    .filter('roundedCzechAmount', ['$filter', function($filter) {
        return function(input) {
            if (isNaN(input)) return input;
            var roundedValue = Math.round(input);
            return $filter('number')(roundedValue, 2);
        };
      }])
    .component('price', priceComponent)
    .component('productFile', productFileComponent)
    .directive('postfix', PostfixDirective.directiveFactory)
    .component('userCategoriesPromoThresholds', userCategoriesPromoThresholdsComponent)
    .component('adminReplacingComarchInvoice', adminReplacingComarchInvoiceComponent)
    .component('adminAddComarchInvoice', adminAddComarchInvoiceComponent)
    .component('paczkomatyTargetPointInpostGeowidget', paczkomatyTargetPointInpostGeowidgetComponent)
    .controller('ToastController', ToastController)
    .service('CheckoutService', CheckoutService)
    .service('SnackbarService', snackbarService)
    .component('checkoutItems', checkoutItemsComponent)
    .component('checkoutShipment', checkoutShipmentComponent)
    .component('checkoutSummary', checkoutSummaryComponent)
    .component('checkoutControls', checkoutControlsComponent)
    .component('checkoutDataLogged', checkoutDataLoggedComponent)
    .component('checkoutDataNotLogged', checkoutDataNotLoggedComponent)
    .component('checkoutAddNewAddress', checkoutAddNewAddressComponent)
    .component('checkoutPayment', checkoutPaymentComponent)
    .component('checkoutConfirmation', checkoutConfirmationComponent)
    .component('snackbar', snackbarComponent)
    .component('cookieWall', cookieWallComponent)
    .component('register', registerComponent)
    .component('userAddress', userAddressComponent)
    .component('uploader', uploaderComponent)
    .component('uploadPrintFileOrderPlaced', uploadPrintFileOrderPlacedComponent)
    .directive('displayWhenBelow', DisplayWhenBelowDirective.directiveFactory)
    .directive('fitContent', FitContentDirective.directiveFactory)
    .component('priceType', priceTypeComponent)
    .service('priceTypeService', priceTypeService)
    .component('orderDetails', orderDetailsComponent)
    .component('myProductsComponent', myProductsComponent)
    .component('materialStiffnessCalculatorComponent', materialStiffnessCalculatorComponent)
    .component('discountClubHistories', discountClubHistoriesComponent)
    .directive('confirmation', ConfirmationDirective.directiveFactory)
    .directive('autogrow', AutogrowDirective.directiveFactory)
    .directive('validNip', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ctrl) {
                // Sprawdzenie, czy pole jest wymagane
                const isRequired = attrs.required !== undefined && attrs.required !== 'false';

                // Czyszczenie wartości na wlocie
                element.on('input', function() {
                    // Zastąpienie wartości tylko cyframi
                    let cleanValue = element.val().replace(/[^0-9]+/g, '');

                    if (cleanValue !== element.val()) {
                        element.val(cleanValue); // Ustaw czystą wartość w polu
                    }

                    scope.$apply(function() {
                        ctrl.$setViewValue(cleanValue); // Ustaw czystą wartość w modelu
                    });
                });

                ctrl.$validators.validNip = function(modelValue, viewValue) {
                    const taxNumber = viewValue || ''; // Użycie pustego stringu, jeśli viewValue jest undefined

                    // Jeśli pole nie jest wymagane i jest puste, zwracamy true
                    if (!isRequired && taxNumber === '') {
                        return true;
                    }

                    // Walidacja NIP, gdy pole jest wymagane lub nie jest puste
                    if (taxNumber.length === 10 && taxNumber !== '1234567890') {
                        const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                        let sum = 0;

                        for (let i = 0; i < 9; i++) {
                            sum += taxNumber[i] * weights[i];
                        }

                        // Obliczanie cyfry kontrolnej
                        let controlNumber = sum % 11;
                        controlNumber = controlNumber === 10 ? 0 : controlNumber;

                        // Porównanie cyfry kontrolnej z ostatnią cyfrą NIP-u
                        return controlNumber === Number(taxNumber[9]);
                    }

                    return false; // NIP nieprawidłowy
                };
            }
        };
    });

configuratorApp.config([
    '$locationProvider', '$urlMatcherFactoryProvider', '$stateProvider', '$urlRouterProvider', '$animateProvider', '$injector', '$provide', '$mdDateLocaleProvider',
    function($locationProvider, $urlMatcherFactoryProvider, $stateProvider, $urlRouterProvider, $animateProvider, $injector, $provide, $mdDateLocaleProvider) {

        $mdDateLocaleProvider.formatDate = function(date) {
            return moment(date).format('YYYY-MM-DD');
        };

        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'YYYY-MM-DD', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        function translate(slug, values) {
            if (typeof slug !== 'string') {
                return undefined;
            }

            const parts = slug.split('.');

            let translate = translations;

            for (const part of parts) {
                if (typeof translate[part] === 'undefined') {
                    return slug;
                }

                translate = translate[part];
            }

            if (values && typeof values === 'object') {
                const keys = Object.keys(values).map(k => `{${k}}`);
                const matches = Object.values(values);

                if (!keys || !matches || keys.length < 1 || keys.length != matches.length) {
                    return translate;
                }

                for (let i = 0; i < keys.length; i++) {
                    translate = translate.replace(keys[i], matches[i]);
                }
            }

            return translate;
        }

        $urlMatcherFactoryProvider.strictMode(false);

        $locationProvider.html5Mode({
            enabled: true,
            rewriteLinks: false,
            requireBase: false
        });

        $stateProvider.state('configurator', {
            url: '/configurator/:materialSlug/:slug1/:slug2',
            component: 'configurator',
            params: {
                'materialSlug': {
                    dynamic: true, value: null, squash: true
                },
                'slug1': {
                    dynamic: true, value: null, squash: true
                },
                'slug2': {
                    dynamic: true, value: null, squash: true
                }
            },
            resolve: {
                materialSlug: $transition$ => $transition$.params().materialSlug,
                slug1: $transition$ => $transition$.params().slug1,
                slug2: $transition$ => $transition$.params().slug2
            }
        });

        $stateProvider.state('configuratorPrints', {
            url: '/configurator/prints',
            component: 'configuratorPrints',
            params: {},
            resolve: {}
        });

        $stateProvider.state('materials', {
            url: '/admpanel/configurator',
            component: 'materials',
            params: {},
            resolve: {}
        });

        $stateProvider.state('configuratorPrintsAdm', {
            url: '/admpanel/configurator/prints',
            component: 'configuratorPrintsAdm',
            params: {},
            resolve: {}
        });

        $stateProvider.state('order', {
            url: '/admpanel/orders/view/:orderId',
            component: 'order',
            resolve: {
                orderId: $transition$ => $transition$.params().orderId
            }
        });

        $stateProvider.state('configuratorManualFe', {
            url: '/user/configurator/manual/thread/:threadId?',
            component: 'configuratorManualFe',
            params: {
                'threadId': {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                threadId: $transition$ => $transition$.params().threadId
            }
        });

        $stateProvider.state('complaintFe', {
            url: '/' + translate('complaint.route', null),
            component: 'complaintFe',
            params: {},
            resolve: {}
        });

        $stateProvider.state('complaintUserNew', {
            url: '/user/complaints/new',
            component: 'complaintFe',
            params: {
                'complaintId': {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                complaintId: () => null
            }
        });

        $stateProvider.state('complaintUserDetails', {
            url: '/user/complaints/details/:complaintId',
            component: 'complaintFe',
            params: {
                'complaintId': {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                complaintId: $transition$ => $transition$.params().complaintId
            }
        });

        $stateProvider.state('complaintAdm', {
            url: '/admpanel/complaints/show/:complaintId',
            component: 'complaintAdm',
            resolve: {
                complaintId: $transition$ => $transition$.params().complaintId
            }
        });

        $stateProvider.state('configuratorManualAdm', {
            url: '/admpanel/configurator/manual/thread/:threadId?',
            component: 'configuratorManualAdm',
            params: {
                'threadId': {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                threadId: $transition$ => $transition$.params().threadId
            }
        });

        $stateProvider.state('dashboard', {
            url: '/admpanel',
            component: 'dashboard',
            params: {},
            resolve: {}
        });

        $stateProvider.state('configuratorManualNewAdm', {
            url: '/admpanel/configurator/manual/new',
            component: 'configuratorManualNewAdm',
            params: {},
            resolve: {}
        });

        $stateProvider.state('configuratorValuationAdmAdd', {
            url: '/admpanel/configurator/valuations/add',
            component: 'configuratorValuationAdm',
            params: {},
            resolve: {}
        });

        $stateProvider.state('configuratorManualAdmEdit', {
            url: '/admpanel/configurator/valuations/edit/:valuationId?',
            component: 'configuratorValuationAdm',
            params: {
                'valuationId': {
                    value: null,
                    squash: true
                }
            },
            resolve: {
                valuationId: $transition$ => $transition$.params().valuationId
            }
        });

        $stateProvider.state('userCategoriesPromoThresholdsAdm', {
            url: '/admpanel/users/categories/promoThresholds/:shopId/:userCategoryId',
            component: 'userCategoriesPromoThresholds',
            resolve: {
                shopId: $transition$ => $transition$.params().shopId,
                userCategoryId: $transition$ => $transition$.params().userCategoryId
            }
        });

        $stateProvider.state('cart', {
            url: '/' + translate('checkout.routes.cart', null),
            views: {
                'checkout': {
                    component: 'checkoutItems',
                },
                'shipment': {
                    component: 'checkoutShipment',
                },
                'summary': {
                    component: 'checkoutSummary',
                    bindings: { step: 'step' },
                    resolve: {
                        step: () => 1
                    }
                }
            }
        });

        $stateProvider.state('cart-data', {
            url: '/' + translate('checkout.routes.order', null) + '/' + translate('checkout.routes.your_data', null),
            views: {
                'summary': {
                    component: 'checkoutSummary',
                }
            }
        });

        $stateProvider.state('confirmation', {
            url: '/' + translate('checkout.routes.order', null) + '/' + translate('checkout.routes.summary', null),
            views: {
                'checkout-confirmation': {
                    component: 'checkoutConfirmation'
                }
            }
        })

        $stateProvider.state('uploadPrintFileOrderPlacedUser', {
            url: '/user/orders/upload-print-file/:orderId/:orderItemId',
            component: 'uploadPrintFileOrderPlaced',
            resolve: {
                orderId: $transition$ => $transition$.params().orderId,
                orderItemId: $transition$ => $transition$.params().orderItemId
            }
        });

        $animateProvider.classNameFilter(/^(?:(?!no-animate).)*$/);

        $provide.decorator('taOptions', ['$delegate', function(taOptions) {
            taOptions.forceTextAngularSanitize = false;

            taOptions.toolbar = [
                ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
                ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
                ['html']
                // ['html', 'insertImage', 'insertLink', 'insertVideo', 'wordcount', 'charcount']
            ];

            return taOptions;
        }]);
    }
]);
